import { render, staticRenderFns } from "./NbuFinancialInstitution.vue?vue&type=template&id=6643515b&"
import script from "./NbuFinancialInstitution.vue?vue&type=script&lang=js&"
export * from "./NbuFinancialInstitution.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports